import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, NavLink } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import BuildingContainer from './building/BuildingContainer';
import MachineryContainer from './machinery/MachineryContainer';
import LandContainer from './land/container/LandContainer';
import SettingsRoutes from './settings/SettingsRoutes';
import RptDashboardContainer from './dashboard/RptDashboardContainer';

function RptContainer({ match }) {
  const permissions = getJson('permissions');
  return (
    <React.Fragment>
      <div className="module-inner">
        <div className="module-inner-title">Real Property Tax</div>
        <div className="generic-module-nav mb-3 custom-module-nav">
          {Acl(permissions, ['E2E RPT DASHBOARD']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/rpt/dashboard"
            >
              Dashboard
            </NavLink>
          )}
          {Acl(permissions, ['E2E RPT LAND']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/rpt/land"
            >
              Land
            </NavLink>
          )}
          {Acl(permissions, ['E2E RPT BUILDING']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/rpt/building"
            >
              Building
            </NavLink>
          )}
          {Acl(permissions, ['E2E RPT MACHINERY']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/rpt/machinery"
            >
              Machinery
            </NavLink>
          )}
          {Acl(permissions, ['E2E RPT SETTINGS']) && (
            <NavLink
              exact={false}
              className="nav-link"
              activeClassName="active"
              to="/rpt/settings"
            >
              Settings
            </NavLink>
          )}
        </div>
        <Switch>
          {Acl(permissions, ['E2E RPT DASHBOARD']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/dashboard`} />}
            />
          )}
          {Acl(permissions, ['E2E RPT DASHBOARD']) && (
            <Route
              path={`${match.path}/dashboard`}
              component={RptDashboardContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT LAND']) && (
            <Route
              path={`${match.path}/land`}
              component={LandContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT BUILDING']) && (
            <Route
              path={`${match.path}/building`}
              component={BuildingContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT MACHINERY']) && (
            <Route
              path={`${match.path}/machinery`}
              component={MachineryContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT SETTINGS']) && (
            <Route
              path={`${match.path}/settings`}
              component={SettingsRoutes}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

RptContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(RptContainer);
